import React, { useEffect, useState } from "react";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation"; // Import navigation styles

// Axios
import axios from "axios";

// Custom Styles
import "../scss/pages/events.styles.scss";

// Assets
import EventMedia1 from "../assets/img/event-media-1.jpg";
import ClockIconBlue from "../assets/img/clock-icon--blue.svg";
import LocationIcon from "../assets/img/location-icon-no-background--blue.svg";
import CustomPrevIcon from "../assets/img/left-arrow--white.svg";
import CustomNextIcon from "../assets/img/right-arrow--white.svg";
import EventsAbout from "../assets/img/events-about.jpg";
import QuotesIcon from "../assets/img/quotes-icon--blue.svg";

function Events() {
  const [eventsPageData, setEventsPageData] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [error, setError] = useState({ error: false, message: "" });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              festividad{
                data{
                  attributes{
                    imagen{
                      imagen{
                          data{
                          attributes{
                            url
                          }
                        }
                      }
                    }
                    Descripcion
                    FestividadesFrase
                    FestividadesImagen{
                      data{
                        attributes{
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          }
        );
        setEventsPageData(
          response.data.data.festividad.data
            ? response.data.data.festividad.data.attributes
            : null
        );
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoading(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              eventos{
                data{
                  id
                  attributes{
                    Nombre
                    Descripcion
                    Fecha
                    ImagenEvento{
                      data{
                          attributes{
                            url
                          }
                        }
                    }
                  }
                }
              }
            }
          `,
          }
        );
        setEventsData(response.data.data.eventos.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoadingEvents(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);

  if (loading || loadingEvents) {
    return (
      <section className="loading">
        <Container>
          <h6>Cargando información...</h6>
        </Container>
      </section>
    );
  }
  if (error.error) {
    return (
      <section className="loading">
        <Container>
          <h6>No se pudo cargar la información en este momento ⌛️</h6>
        </Container>
      </section>
    );
  }
  const now = new Date();
  const currentMonth = now.getMonth(); // Months are 0-based, so 0 = January, 1 = February, etc.
  const currentYear = now.getFullYear();

  const events = eventsData;

  // Separate events into current month and future events
  const eventsThisMonth = events.filter((event) => {
    const eventDate = new Date(event.attributes.Fecha);
    return (
      eventDate.getMonth() === currentMonth &&
      eventDate.getFullYear() === currentYear
    );
  });

  const futureEvents = events.filter((event) => {
    const eventDate = new Date(event.attributes.Fecha);
    return (
      eventDate.getMonth() > currentMonth ||
      eventDate.getFullYear() > currentYear
    );
  });

  return (
    <>
      <section
        className="events__jumbotron"
        style={{
          backgroundImage: `linear-gradient(
            180deg,
           rgba(0, 70, 125, 0.22) 0%,
           #00467d 200%
         ),url(${eventsPageData.imagen.imagen.data.attributes.url})`,
          // backgroundImage: `url(${process.env.REACT_APP_API_URL}${eventsPageData.imagen.imagen.data.attributes.url})`,
        }}
      >
        <h3>Eventos</h3>
      </section>
      <section className="events__latest-events">
        <Container fluid>
          <p>{eventsPageData.Descripcion}</p>
          <div className="events__latest-events__list">
            {eventsThisMonth.map(({ attributes }, key) => (
              <div className="events__latest-events__list__item" key={key}>
                <div className="events__latest-events__list__item__media">
                  <img
                    src={attributes.ImagenEvento.data.attributes.url}
                    alt=""
                    className="img-fluid"
                  />
                  {/* {console.log(attributes)} */}
                </div>
                <div className="events__latest-events__list__item__body">
                  <div className="events__latest-events__list__item__body__date">
                    <h5>
                      {new Date(attributes.Fecha).toLocaleString("es-MX", {
                        // month: "short",
                        day: "numeric",
                        // hour12: true,
                      })}
                    </h5>
                    <h6>
                      {" "}
                      {new Date(attributes.Fecha).toLocaleString("es-MX", {
                        month: "short",
                      })}
                    </h6>
                  </div>
                  <div className="events__latest-events__list__item__body__details">
                    <h4>{attributes.Nombre}</h4>
                    <div>
                      <img src={ClockIconBlue} alt="" />
                      <p>
                        {" "}
                        {new Date(attributes.Fecha).toLocaleString("es-MX", {
                          hour: "numeric",
                          hour12: true,
                        })}
                      </p>
                    </div>
                    <div>
                      <img src={LocationIcon} alt="" />
                      <p>Salón de usos múltiples</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* <div className="events__latest-events__list__item">
              <div className="events__latest-events__list__item__media">
                <img src={EventMedia1} alt="" className="img-fluid" />
              </div>
              <div className="events__latest-events__list__item__body">
                <div className="events__latest-events__list__item__body__date">
                  <h5>18</h5>
                  <h6>ago</h6>
                </div>
                <div className="events__latest-events__list__item__body__details">
                  <h4>Ceremonia de Graduación. Generación 2020-2024</h4>
                  <div>
                    <img src={ClockIconBlue} alt="" />
                    <p>13:00</p>
                  </div>
                  <div>
                    <img src={LocationIcon} alt="" />
                    <p>Salón de usos múltiples</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="events__latest-events__list__item">
              <div className="events__latest-events__list__item__media">
                <img src={EventMedia1} alt="" className="img-fluid" />
              </div>
              <div className="events__latest-events__list__item__body">
                <div className="events__latest-events__list__item__body__date">
                  <h5>18</h5>
                  <h6>ago</h6>
                </div>
                <div className="events__latest-events__list__item__body__details">
                  <h4>Ceremonia de Graduación. Generación 2020-2024</h4>
                  <div>
                    <img src={ClockIconBlue} alt="" />
                    <p>13:00</p>
                  </div>
                  <div>
                    <img src={LocationIcon} alt="" />
                    <p>Salón de usos múltiples</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="events__latest-events__list__item">
              <div className="events__latest-events__list__item__media">
                <img src={EventMedia1} alt="" className="img-fluid" />
              </div>
              <div className="events__latest-events__list__item__body">
                <div className="events__latest-events__list__item__body__date">
                  <h5>18</h5>
                  <h6>ago</h6>
                </div>
                <div className="events__latest-events__list__item__body__details">
                  <h4>Ceremonia de Graduación. Generación 2020-2024</h4>
                  <div>
                    <img src={ClockIconBlue} alt="" />
                    <p>13:00</p>
                  </div>
                  <div>
                    <img src={LocationIcon} alt="" />
                    <p>Salón de usos múltiples</p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </Container>
      </section>
      <section className="upcoming-events">
        <Container fluid>
          <h4>Próximos eventos</h4>
          <div className="upcoming-events__c">
            {futureEvents.length > 0 ? (
              <Swiper
                modules={[Navigation]}
                spaceBetween={30}
                slidesPerView={1}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                }}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                pagination={{ clickable: true }}
              >
                {futureEvents.map(({ attributes }, key) => (
                  <SwiperSlide>
                    <div className="upcoming-event" key={key}>
                      <div className="upcoming-event__heading">
                        <h5>
                          {new Date(attributes.Fecha).toLocaleString("es-MX", {
                            month: "short",
                            day: "numeric",
                          })}
                        </h5>
                        <p>
                          {" "}
                          {new Date(attributes.Fecha).toLocaleString("es-MX", {
                            hour: "numeric",
                            hour12: true,
                          })}
                        </p>
                      </div>
                      <div className="upcoming-event__body">
                        <h6>{attributes.Nombre}</h6>
                        <p>{attributes.Descripcion}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}

                {/* <SwiperSlide>
                <div className="upcoming-event">
                  <div className="upcoming-event__heading">
                    <h5>05 Ago</h5>
                    <p>9 am</p>
                  </div>
                  <div className="upcoming-event__body">
                    <h6>Evento de prueba 01</h6>
                    <p>
                      Vive un emocionante evento de prueba en las canchas de
                      basketball
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="upcoming-event">
                  <div className="upcoming-event__heading">
                    <h5>05 Ago</h5>
                    <p>9 am</p>
                  </div>
                  <div className="upcoming-event__body">
                    <h6>Evento de prueba 01</h6>
                    <p>
                      Vive un emocionante evento de prueba en las canchas de
                      basketball
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="upcoming-event">
                  <div className="upcoming-event__heading">
                    <h5>05 Ago</h5>
                    <p>9 am</p>
                  </div>
                  <div className="upcoming-event__body">
                    <h6>Evento de prueba 01</h6>
                    <p>
                      Vive un emocionante evento de prueba en las canchas de
                      basketball
                    </p>
                  </div>
                </div>
              </SwiperSlide> */}

                {/* Custom Navigation Buttons */}
              </Swiper>
            ) : (
              <p style={{ color: "#fff", fontSize: "1.5rem" }}>
                No hay eventos futuros.
              </p>
            )}
            <div className="swiper-button-prev">
              <img src={CustomPrevIcon} alt="Previous" />
            </div>
            <div className="swiper-button-next">
              <img src={CustomNextIcon} alt="Next" />
            </div>
          </div>
        </Container>
      </section>
      <section className="events__about">
        <div className="events__about__content">
          <img src={QuotesIcon} alt="" />
          <h3>{eventsPageData.FestividadesFrase}</h3>
        </div>
        <div
          className="events__about__media"
          style={{
            backgroundImage: `url(${eventsPageData.FestividadesImagen.data.attributes.url})`,
            // backgroundImage: `url(${process.env.REACT_APP_API_URL}${eventsPageData.FestividadesImagen.data.attributes.url})`,
          }}
          // style={{ backgroundImage: `url(${EventsAbout})` }}
        >
          {/* <img src={EventsAbout} className="img-fluid" alt="" srcset="" /> */}
        </div>
      </section>
    </>
  );
}

export default Events;
